export function useQueryParam() {
  const search = new URLSearchParams(window.location.search).entries();
  const queryParam = [...search].reduce((prev, item) => {
    return {
      ...prev,
      [item[0]]: item[1],
    };
  }, {});
  return queryParam;
}
